import * as React from 'react';
import { Text as RNText, StyleSheet, Platform } from 'react-native';
import _ from 'lodash';
import Text from 'design-system/Text';
import LinkHelpers from 'utils/links';
import { navigationRef } from 'utils/navigationv6';
const process = (s, links, linkColor, boldLinks, pdf) => {
    const linkTexts = Object.keys(links);
    if (linkTexts.length === 0)
        return s;
    const linkText = Object.keys(links)[0];
    const parts = s.split(linkText);
    const remainingLinks = _.omit(links, [linkText]);
    if (parts.length === 1)
        return process(parts[0], remainingLinks, linkColor, boldLinks);
    const result = [process(parts[0], remainingLinks, linkColor, boldLinks)];
    for (let i = 1; i < parts.length; i += 1) {
        result.push(<RNText key={linkText} style={[{ color: linkColor }, boldLinks && styles.bold]} onPress={() => {
                if (pdf && Platform.OS === 'android') {
                    navigationRef.navigateDeprecated('Pdf', { url: links[linkText] });
                }
                else {
                    LinkHelpers.openLink(links[linkText], true);
                }
            }} allowFontScaling={false}>
        {linkText}
      </RNText>);
        result.push(process(parts[i], remainingLinks, linkColor, boldLinks));
    }
    return _.flatten(result);
};
const TapableText = (props) => {
    const { links, linkColor, text, boldLinks, pdf, ...otherProps } = props;
    return <Text {...otherProps}>{process(text, links, linkColor, boldLinks, pdf)}</Text>;
};
const styles = StyleSheet.create({
    bold: {
        fontWeight: '500',
    },
});
export default TapableText;
